import { render, staticRenderFns } from "./ScadaAdmin.vue?vue&type=template&id=440be694&"
import script from "./ScadaAdmin.vue?vue&type=script&lang=js&"
export * from "./ScadaAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports